<div
  class="custom-select-wrapper"
  [ngClass]="style?.wrapper"
  (mouseleave)="closeDropdown()"
  (click)="openCloseSelector($event)"
  *ngIf="!isDisabled">
  <div class="custom-select" [ngClass]="{ open: open, 'b-0': style?.customSelect }">
    <div class="custom-select__trigger" [ngClass]="[style?.trigger, style?.activities ? 'custom-select__activities' : '']">
      <span [ngClass]="style.placeholder" *ngIf="!style?.noMargins">
        {{ selectedOpt === '' ? placeholder : (selectedOpt | translate) }}
      </span>
      <ng-container *ngIf="config.svg.isShow">
        <svg-icon
          *ngIf="!isHelpMenu"
          class="rounded-full iconDefaultSize {{ config.svg.style.customClass }}"
          [ngClass]="svg !== 'options' ? 'hover:' + config.svg.style.cBackgroundHover : ''"
          [color]="config.svg.style.color"
          [key]="svg === 'options' ? 'options-2' : open ? config.svg.iconOpen : config.svg.iconClose"
          [size]="svg === 'options' ? 'xl' : 'sm'"></svg-icon>
        <svg-icon
          *ngIf="isHelpMenu"
          class="rounded-full p-2 iconSize {{ config.svg.style.customClass }}"
          [color]="config.svg.style.color"
          [ngClass]="open ? 'hover:bg-purple_shadow' : 'hover:bg-fondoGrisClaro'"
          [key]="open ? 'help-purple' : 'help-black'"></svg-icon>
      </ng-container>
    </div>
    <div class="custom-options-container" [ngClass]="style?.container">
      <div class="custom-options">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
